import { getVisitorAppointment, getSafetyInstructions } from '../api';
import { getDeptList, getPark, getVisitSubject } from '../../../../api/selects'
const visitorAppointment = {
  namespaced: true,
  state: {
    appointmentData: null,
    safetyContent: '',
    deptList: [],
    parkList: [],
    visitSubjectList: []
  },
  mutations: {
    GET_VISITOR_APPOINTMENT(state, resp) {
      state.appointmentData = resp;
    },
    GET_SAFETY_INSTRUCTIONS(state, resp) {
      state.safetyContent = resp;
    },
    GET_DEPT_LIST(state, resp) {
      state.deptList = resp;
    },
    GET_PARK_LIST(state, resp) {
      state.parkList = resp;
    },
    GET_VISIT_SUBJECT_LIST(state, resp) {
      state.visitSubjectList = resp;
    }
  },
  actions: {
    async getVisitorAppointment({ commit }, obj) {
      let resp = await getVisitorAppointment(obj);
      commit('GET_VISITOR_APPOINTMENT', resp);
    },
    async getSafetyInstructions({ commit }, obj) {
      let resp = await getSafetyInstructions(obj);
      commit('GET_SAFETY_INSTRUCTIONS', resp);
    },
    async getDeptList({ commit }, obj) {
      let resp = await getDeptList(obj);
      commit('GET_DEPT_LIST', resp);
    },
    async getPark({ commit }, obj) {
      let resp = await getPark(obj);
      commit('GET_PARK_LIST', resp);
    },
    async getVisitSubject({ commit }, obj) {
      let resp = await getVisitSubject(obj);
      commit('GET_VISIT_SUBJECT_LIST', resp);
    }
  }
}

export default visitorAppointment



// WEBPACK FOOTER //
// ./src/page/visitor/visitorAppointment/store/visitorAppointment.store.js